<template>
  <b-dropdown :dropleft="dropleft" :right="right" variant="link" :menu-class="'context-menu dropdown-custom__menu'"
              toggle-class="btn-event-options ml-2 text-decoration-none"
              class="dropdown-custom"
              no-caret>
    <template #button-content>
      <Icon name="dotsVertical" :class="iconClass" :width="iconSize"/>
    </template>
    <!-- CHECKIN CODE -->
    <b-dropdown-text>{{ $t('pages.checkins.pica_code') }}: <span class="code">{{ checkin.picacode }}</span>
    </b-dropdown-text>

    <!-- CHECKIN QR CODE -->
    <b-dropdown-item href="#" @click.prevent="$emit('show-qr-picacode')" v-if="checkin.show_qrcode">
      <Icon name="qrCode" :width="18" class="mr-1" vertical-align="sub"/>
      {{ $t('pages.checkins_detail.btn_show_qr_picacode') }}
    </b-dropdown-item>

    <!-- DOWNLOAD CHECKIN -->
    <b-dropdown-item href="#" @click.prevent="downloadAlbum" v-if="checkin.can_download_hd">
      <Icon name="download" :width="18" class="mr-1" vertical-align="sub"/>
      {{ $t('pages.checkins_detail.btn_download_album') }}
    </b-dropdown-item>

    <!-- ANONYMIZE CHECKIN -->
    <template v-if="checkinAnonymizeStatus !== ANONYMIZATION_STATUS.unavailable">
      <b-dropdown-item href="#" @click.prevent="$emit('anonymize-album')"
                       :disabled="checkinAnonymizeStatus === ANONYMIZATION_STATUS.pending">
        <div class="d-flex flex-column event-summary__anonymize">
          <div class="d-flex align-items-center justify-content-between">
            <div class="mr-2">
              <Icon name="faceHappy" :width="18" vertical-align="sub" class="mr-1"/>
              {{ $t('pages.checkins_detail.btn_anonymize') }}
            </div>
            <b-form-checkbox :disabled="checkinAnonymizeStatus === ANONYMIZATION_STATUS.pending"
                             :checked="checkinAnonymizeStatus === ANONYMIZATION_STATUS.completed"
                             name="check-button" switch/>
          </div>
        </div>
      </b-dropdown-item>
      <b-dropdown-text class="hint">
        <template v-if="checkinAnonymizeStatus === ANONYMIZATION_STATUS.available">
          {{ $t('pages.checkins_detail.anonymous_mode_off_hint', {'eventName': checkin.pica_service.event_name}) }}
        </template>
        <template v-if="checkinAnonymizeStatus === ANONYMIZATION_STATUS.completed">
          {{ $t('pages.checkins_detail.anonymous_mode_on_hint') }}
        </template>
        <template v-if="checkinAnonymizeStatus === ANONYMIZATION_STATUS.pending">
          {{ $t('pages.checkins_detail.btn_anonymize_pending') }}
        </template>
      </b-dropdown-text>
    </template>

    <!-- REMOVE CHECKIN -->
    <b-dropdown-item href="#" @click.prevent="$emit('remove-album')">
      <Icon name="trash" :width="18" vertical-align="sub" class="mr-1"/>
      {{ $t('pages.checkins_detail.btn_remove_album') }}
    </b-dropdown-item>
    <b-dropdown-text class="hint" v-if="showDeleteHelpText">
      {{ $t('pages.checkins_detail.btn_remove_album_help') }}
    </b-dropdown-text>
  </b-dropdown>
</template>

<script>

import {ANONYMIZATION_STATUS} from "@/components/ModalAnonymizeCheckin.vue";
import EventService from "@/services/Event";

export default {
  name: "CheckinMenu",

  props: {
    checkin: {
      type: Object,
      required: true,
    },
    iconSize: {
      type: Number,
      default: 33,
    },
    iconClass: {
      type: String,
      default: '',
    },
    dropleft: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },

  },

  computed: {
    showDeleteHelpText() {
      return this.checkin && this.checkin.has_checkin_faces
    },
    ANONYMIZATION_STATUS() {
      return ANONYMIZATION_STATUS
    },
    checkinAnonymizeStatus() {
      return this.checkin.anonymize_status
    },
  },
  methods: {
    downloadAlbum() {
      EventService.downloadAlbum(this.checkin.checkin_id)
          .then(response => {
            this.$bvToast.toast(
                this.$t('toast_download_album.text'),
                {
                  title: this.$t('toast_download_album.title'),
                  headerClass: 'd-block pt-2',
                  noCloseButton: false,
                  autoHideDelay: 5000
                })
          })
          .catch(error => {
            if (error.response.status === 400 && error.response.data.code === 'bulk_download_not_available') {
              this.$bvToast.toast(
                  error.response.data.detail,
                  {variant: 'warning', autoHideDelay: 5000})
            }
          })
    },
  },
}
</script>
